class Monitoring.Views.InstagramMessageContentViewFactory

  create: (analysisUnit) ->
    switch (analysisUnit.get('content').message.getType())
      when 'unsupported' then Monitoring.Views.SocialContents.InstagramUnsupportedMessageView
      when 'story_mention' then Monitoring.Views.SocialContents.InstagramStoryMentionMessageView
      when 'media' then Monitoring.Views.SocialContents.InstagramMediaMessageView
